import { defineComponent } from 'vue';
import Dialog from './doyo.dialog.comp.js';
import { useWindowSize } from '@vueuse/core';
import { useState, useMemo } from './doyo.useReactHooks.js';
import { useLogger } from './doyo.useLogger.js';
import { useShipDate } from './doyo.useShipDate.js';
import { isMobile } from './doyo.utils.js';
import 'jquery';

export default defineComponent({
  name: 'ShipTipDialog',
  components: {
    Dialog,
  },
  template: `
		<Dialog
			ref="dialogRef"
			class="ship-dialog"
			:visible="visible"
			:closeOnClickMask="true"
      :mobile-center="true"
			@close="close"
		>
			<div class="ship-dialog-content" :class="[normalPCScreen ? 'pc' : 'mobile']">
				<div class="steps">
					<img :src="icn_ship_icon1" alt="" class="step-item icn icn-ship" />
					<img :src="icn_ship_icon2" alt="" class="step-item icn icn-ship" />
					<img :src="icn_ship_icon3" alt="" class="step-item icn icn-ship" />
				</div>
				<div class="steps-desc">
					<div class="step-desc-item" v-for="(item, index) in dateTips" :key="index">
						<div class="step-desc-item-date">{{item.date}}</div>
						<div class="step-desc-item-desc">{{item.desc}}</div>
					</div>
				</div>
				<ul class="tip-list">
					<li v-for="(item, index) in tips" :key="index">{{item}}</li>
				</ul>
			</div>
		</Dialog>
	`,
  setup() {
    const { Log } = useLogger('ShipDialog');
    const [visible, setVisible] = useState(false);

    const [icn_ship_icon1] = useState(GLOBAL_ICN_SHIP_ICON1);
    const [icn_ship_icon2] = useState(GLOBAL_ICN_SHIP_ICON2);
    const [icn_ship_icon3] = useState(GLOBAL_ICN_SHIP_ICON3);

    const { placedDate, shipTime, deliveredTime } = useShipDate();

    const [dateTips] = useState([
      {
        date: placedDate,
        desc: 'Order placed',
      },
      {
        date: shipTime,
        desc: 'Order ship',
      },
      {
        date: deliveredTime,
        desc: 'Delivered!',
      },
    ]);

    const [tips] = useState([
      'Orders can be cancelled or modified within 3 hours after being placed.',
      'The above time frame is applied with standard shipping methods.',
      'If a design error or defect is found after placing an order, we will provide a free design modification service, but the order will be delayed by 2-4 days.',
      "All customized products go through strict quality checks twice. If product needs to be remade due to quality issues, we'll upgrade your shipping to express for free to ensure timely delivery.",
    ]);

    const onTouchStart = evt => {
      Log(evt);
      evt.preventDefault();
    };

    const { width } = useWindowSize();

    const isPlatformMobile = useMemo(() => isMobile());

    const smallScreen = useMemo(() => width.value <= 1024);

    const normalPCScreen = useMemo(() => !smallScreen.value && !isPlatformMobile.value);

    return {
      visible,
      open() {
        setVisible(true);
        $('body').addClass('overflow-hidden');
      },
      close() {
        setVisible(false);
        $('body').removeClass('overflow-hidden');
      },
      icn_ship_icon1,
      icn_ship_icon2,
      icn_ship_icon3,
      dateTips,
      tips,
      onTouchStart,
      normalPCScreen,
    };
  },
  expose: ['open', 'close'],
});
